module.exports = __webpack_public_path__ + "static/media/Lee Gordon Headshot_1643903412037.c8e52651.jpeg";